export default __webpack_public_path__ + "static/media/seller2.84fe1671.jpg";